import React, { useState } from 'react';
import "./PartBookingDate.css"
import {useNavigate} from "react-router-dom"
import Navbar from "../Navbar/Navbar"
import Stepper from "../PartyBooking/Stepper/Stepper"


const PartBookingDate = () => {
  const navigate = useNavigate()
  // Initial state set to March 2026 as per your image
  const [currentDate, setCurrentDate] = useState(new Date(2026, 2, 1));

  const daysOfWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  // Helper to get calendar details
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const monthName = currentDate.toLocaleString('default', { month: 'long' });

  // Get first day of month (0-6) and total days in month
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Create an array for the grid (including empty slots for padding)
  const calendarGrid = [
    ...Array(firstDayOfMonth).fill(null),
    ...Array.from({ length: daysInMonth }, (_, i) => i + 1)
  ];

  const changeMonth = (offset) => {
    setCurrentDate(new Date(year, month + offset, 1));
  };

  

  const handleDay = (day)=>{
    navigate("/portal/booking/party/party-booking-02-timeslot",{state:day})
  }


  return (
    <div className="kiga-portal-partBook-main">
     <Navbar />
     <div className="kiga-portal-partBook-head-title">
      <p>Party Booking</p>
     </div>
     <Stepper/>
     <section className='kiga-portal-partBook-section'>
      <div style={styles.card}>

      <div style={styles.header}>
        <button onClick={() => changeMonth(-1)} style={styles.navBtn}>←</button>
        <h2 style={styles.monthTitle}>{monthName} {year}</h2>
        <button onClick={() => changeMonth(1)} style={styles.navBtn}>→</button>
      </div>

  
      <div style={styles.grid}>
        {daysOfWeek.map(day => (
          <div key={day} style={styles.dayLabel}>{day}</div>
        ))}


        {calendarGrid.map((day, index) => {
          const isWeekend = index % 7 === 0 || index % 7 === 6;
          return (
            <div key={index} style={styles.dayCell}>
              {day && (
                <span style={{
                  ...styles.dayNumber,
                  ...(isWeekend ? styles.weekendCircle : styles.weekdayText)
                }}onClick={() => handleDay(day)} >
                  {day}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
     </section>
    </div>
  );
};

// Inline Styles to match your image
const styles = {
  card: {
    width: '400px',
    background: '#fff',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    fontFamily: 'sans-serif',
    margin: '20px auto'
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '30px'
  },
  monthTitle: { fontSize: '1.2rem', fontWeight: '400', color: '#555', margin: 0 },
  navBtn: {
    border: '1px solid #eee',
    background: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    color: '#ccc'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    textAlign: 'center',
    rowGap: '15px'
  },
  dayLabel: { color: '#aaa', fontSize: '0.85rem', marginBottom: '10px',cursor:'pointer'},
  dayCell: { height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center',cursor:'pointer'},
  dayNumber: { fontSize: '0.9rem', cursor: 'pointer' },
  weekdayText: { color: '#ccc' },
  weekendCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    border: '1px solid #eee',
    borderRadius: '50%',
    color: '#333'
  }
};

export default PartBookingDate;
